module.exports = __webpack_public_path__ + "media/images/logo-compleet-5e0d2911f435e0e8c872c3e697017f1a.svg";